import { writable } from 'svelte/store'

const hash = window.location.hash
const defaultStartStep = 1
export const step = writable(hash ? Number(hash.substr(1)) : defaultStartStep)
export const enquiry = writable({});
